// src/components/ImageVerification.js

import React, { useRef, useEffect } from 'react';

function ImageVerification({ imageFile, selectedPoints, onConfirm, onAdjust, realAge }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.src = URL.createObjectURL(imageFile);

    img.onload = () => {
      // Set the canvas size to the image size
      canvas.width = img.width;
      canvas.height = img.height;

      // Draw the original image
      ctx.drawImage(img, 0, 0, img.width, img.height);

      // Draw all selected points
      selectedPoints.forEach((point) => {
        ctx.fillStyle = point.category === 'blue' ? 'blue' : 'red';
        ctx.beginPath();
        ctx.arc(point.x, point.y, 5, 0, 2 * Math.PI);
        ctx.fill();

        // Draw rectangle only for points in 'blue' category
        if (point.category === 'blue') {
          ctx.strokeStyle = 'blue';
          ctx.lineWidth = 1;
          ctx.setLineDash([10, 5]); // Dashed lines: 10px line, 5px space
          const rectWidth = 250;
          const rectHeight = 350;
          ctx.strokeRect(
            point.x - rectWidth / 2,
            point.y - rectHeight / 2,
            rectWidth,
            rectHeight
          );
          ctx.setLineDash([]); // Reset line dash
        }
      });
    };

    // Cleanup
    return () => {
      URL.revokeObjectURL(img.src);
    };
  }, [imageFile, selectedPoints]);

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
      <h2>Verify Sub-image Selection</h2>
      <p>
        Blue points will be annotated, red points indicate damaged areas and will not
        be considered in the annotation.
      </p>
      {realAge && (
        <p>
          <strong>Real Age:</strong> {realAge}
        </p>
      )}
      <div style={{ position: 'relative', width: '100%' }}>
        <canvas
          ref={canvasRef}
          style={{ width: '100%', height: 'auto', border: '1px solid #ccc' }}
        />
      </div>
      <div style={{ marginTop: '10px', textAlign: 'center' }}>
        <button
          onClick={onConfirm}
          style={{ marginRight: '10px', padding: '10px 20px', cursor: 'pointer' }}
        >
          Confirm Selection
        </button>
        <button
          onClick={onAdjust}
          style={{ padding: '10px 20px', cursor: 'pointer' }}
        >
          Adjust Selection
        </button>
      </div>
    </div>
  );
}

export default ImageVerification;
